export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          <div>
            <span className="font-heading text-xl font-black tracking-tight text-background-50">
              91黑料网
            </span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              91黑料网每日更新最新黑料吃瓜爆料视频，提供91黑料网在线观看服务，是用户获取娱乐八卦与黑料事件的首选平台。本站实时追踪娱乐圈动态，为吃瓜群众提供第一手黑料资讯。
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '最新爆料', href: '#updates' },
                { label: '黑料精选', href: '#cards' },
                { label: '热门榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              更多板块
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门视频', href: '#media' },
                { label: '热门话题', href: '#topics' },
                { label: '专题合集', href: '#index' },
                { label: '网友热评', href: '#comments' },
                { label: '移动端入口', href: '#app' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              合作伙伴
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              诚挚期待与更多优质内容平台携手合作，共同打造健康向上的娱乐资讯生态。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-arrow-up-line text-sm"></i>
              </a>
            </div>
          </div>

        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800">
          <p className="text-center text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 91黑料网 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}